// Api.
import api from './Base';
import { showError } from '../utils/showAlert';

const TagsApi = {
    getAllTags: async () => {
        let url = `datasource/tag`;

        let tags: any[] = [];

        await api.get<any[]>(url)
                .then((response) => {
                    tags = response.data;
                })
                .catch((error: any) => {
                    console.error('Failed to retrieve tags.', error);
                    showError('Failed to retrieve tags', error.message || error.toString());
                });

        const uniqueTags = new Set();
        const uniqueObjects = [];

        for (const obj of tags) {
            const tagKey = `${obj.tagname}:${obj.tagvalue}`;
            if (!uniqueTags.has(tagKey)) {
                uniqueTags.add(tagKey);
                const { id, ...rest } = obj;
                uniqueObjects.push(rest);
            }
        }
        return uniqueObjects;
    },

}

export default TagsApi;